import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {Ordine} from "../../../models/Ordine";
import {TIPO_RETTIFICA} from "../../../pages/root/esercizio/pvendita/pv-rettifiche/rettifica/rettifica.component";

@Component({
   selector: 'app-tabella-riepilogo-ordine',
   templateUrl: './tabella-riepilogo-ordine.component.html',
   styleUrls: ['./tabella-riepilogo-ordine.component.scss']
})
export class TabellaRiepilogoOrdineComponent implements OnInit, OnChanges {

   @Input() ordiniSlave
   @Input() ordine
   @Input() tipoRettifica = ''
   @Input() hasTotals = false

   TIPO_RETTIFICA = TIPO_RETTIFICA;
   Ordine = Ordine;

   qtaTot = 0

   constructor() { }

   ngOnInit(): void {
      console.log(this.tipoRettifica)
   }

   ngOnChanges(changes: SimpleChanges): void {
      this.getQtaTot()
   }

   getQtaTot(){
      this.qtaTot = 0
      for (let ordineSlave of this.ordiniSlave){
         this.qtaTot = this.qtaTot + ordineSlave?.data?.qta!
      }
   }

}
